import React from 'react';
import ReactDOM from 'react-dom';
// Use our async LaunchDarkly wrapper to avoid flicker
import LaunchDarklyProvider from './providers/LaunchDarklyProvider';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import ErrorBoundary from './MLDE/components/ErrorBoundary';
import App from './App';
import { getLDClientIdByHost } from './GA/utils/commonFunctions';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });
const store = configureStore(history);

// Read LD client ID from CRA env; avoids private registry imports in client bundle
const ldClientSideId = getLDClientIdByHost();
console.log('Using LaunchDarkly Client Side ID:', ldClientSideId);
const launchDarklyConfig = {
  clientSideID: ldClientSideId,
};

const AppTree = (
  <React.StrictMode>
    <Provider store={store}>
      <Router
        basename="/userver"
        location={history.location}
        navigator={history}
        history={history}
      >
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Router>
    </Provider>
  </React.StrictMode>
);

ReactDOM.render(
    <LaunchDarklyProvider launchDarklyConfig={launchDarklyConfig}>
      {AppTree}
    </LaunchDarklyProvider>,
  document.getElementById('root')
);
